/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { useViewport } from '@vlinder-web/viewport-provider-react';
import { Document, Page, pdfjs } from 'react-pdf';
import { ButtonWithIcon } from '@vlinder-web/button-v2-widget-react';
import { Navbar, Button, ButtonGroup, Container } from 'react-bootstrap';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { useBreakpoint } from '@vlinder-web/breakpoint-hook-widget-react';
import * as S from './styles';
import { StorageModule } from '@vlinder-web/storage-module-react';
import axios from 'axios';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export interface IPdfViewerProps {
  file: string;
  title?: string;
  onPdfClose?(): void;
  closeTitleLabel?: string;
  maxPageWidth?: number;
  maxPageHeight?: number;
  loadingPdfTitle?: string;
  loadingPdfIllustration?: string;
  loadingPdfDescription?: string;
}

export const PdfViewer = ({
  file,
  title,
  onPdfClose,
  closeTitleLabel,
  maxPageWidth,
  maxPageHeight,
  loadingPdfTitle,
  loadingPdfIllustration,
  loadingPdfDescription,
}: IPdfViewerProps) => {
  const { width } = useViewport();
  const breakpoint = useBreakpoint();
  const [numPages, setNumPages] = React.useState(null);
  const [documentData, setDocumentData] = useState(null);
  const storageSrv = StorageModule.getInstance();
    let _sessionToken = storageSrv.get('userProfile', 'session');
    let _localToken = storageSrv.get('userProfile', 'local');
    let _userToken = _sessionToken ?? _localToken;
  let _token = _userToken?.accessToken;
  console.log("pdfviewer-->file",_token)
  useEffect(() => {
    const fetchPrivateDocument = async () => {
      try {
        
        const response = await axios.get(file, {
          headers:{
            'Content-Type': 'application/json',
            Authentication:`${_token}`,
          }
        }).then(data=>{
          console.log("zcsdfsa",data);
          const documentBlob = new Blob([data?.data], { type: 'application/pdf' });
        console.log("pdfviewer-->file-->blob",documentBlob)
        setDocumentData(documentBlob);
        }).catch(err=>console.log("zcsdfsa",err));
       
        
      } catch (error) {
        console.error('Error fetching private document:', error);
      }
    };

    fetchPrivateDocument();
  }, []);
  function onDocumentLoadSuccess({ numPages }: any) {
    setNumPages(numPages);
  }

  const _getImageWidth = () => {
    let _width = 350;
    if (breakpoint === 'xs' || breakpoint === 'sm') {
      return (_width = 300);
    }
    return _width;
  };

  const PdfLoadingComp = () => {
    return (
      <div
        style={{
          backgroundColor: '#fff',
          width: width,
          height: '100vh',
        }}
      >
        <StateOSD
          image={loadingPdfIllustration}
          titleNormalText={loadingPdfTitle}
          titleBoldText={''}
          description={loadingPdfDescription}
        />
      </div>
    );
  };

  return (
    <>
      {file && (
        <>
          <div style={S.DocumentContainer}>
            <Document
              file={documentData}
              onLoadSuccess={onDocumentLoadSuccess}
              loading={PdfLoadingComp}
            >
              {Array.from(new Array(numPages), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  width={Math.min(width, maxPageWidth ?? _getImageWidth())}
                  height={maxPageHeight ?? 300}
                />
              ))}
            </Document>
          </div>
        </>
      )}
    </>
  );
};

PdfViewer.defaultProps = {
  closeTitleLabel: '',
  maxPageWidth: 350,
  maxPageHeight: 300,
  loadingPdfTitle: 'Loading PDF Document',
  loadingPdfIllustration:
    'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/bc_verificaiton_illustration.png',
  loadingPdfDescription: 'This might take few seconds, Please wait !',
};
